
import {
    GET_PAYMENT,
    GET_PAYMENT_SUCCESS,
    GET_PAYMENT_ERROR,
    GET_PAYMENT_METHOD,
    GET_PAYMENT_METHOD_SUCCESS,
    GET_PAYMENT_METHOD_ERROR,
    GET_PAYMENT_METHOD_CREATED_BY,
    GET_PAYMENT_METHOD_CREATED_BY_SUCCESS,
    GET_PAYMENT_METHOD_CREATED_BY_ERROR,
  } from "../actions";

  export const getPayment = (paymentId, activityInfo) => ({
    type: GET_PAYMENT,
    payload: { paymentId, activityInfo},
  });
  
  export const getPaymentSuccess = (paymentData) => ({
    type: GET_PAYMENT_SUCCESS,
    payload: paymentData,
  });
  
  export const getPaymentError = (message) => ({
    type: GET_PAYMENT_ERROR,
    payload: { message },
  });
  export const getPaymentMethod = (methodId, activityInfo) => ({
    type: GET_PAYMENT_METHOD,
    payload: { methodId, activityInfo },
  });
  
  export const getPaymentMethodSuccess = (paymentMethod) => ({
    type: GET_PAYMENT_METHOD_SUCCESS,
    payload: paymentMethod,
  });
  
  export const getPaymentMethodError = (message) => ({
    type: GET_PAYMENT_METHOD_ERROR,
    payload: { message },
  });
  export const getPaymentMethodCreatedBy = (createdById, activityInfo) => ({
    type: GET_PAYMENT_METHOD_CREATED_BY,
    payload: { createdById, activityInfo },
  });
  
  export const getPaymentMethodCreatedBySuccess = (paymentCreatedBy) => ({
    type:GET_PAYMENT_METHOD_CREATED_BY_SUCCESS,
    payload: paymentCreatedBy,
  });
  
  export const getPaymentMethodCreatedByError = (message) => ({
    type:GET_PAYMENT_METHOD_CREATED_BY_ERROR,
    payload: { message },
  });